import jpath from 'jsonpath';

export default {
  data() {
    return {
      rowProperty: null,
      toolTipDelay: { delay: { "show": 500, "hide": 100 } }
    };
  },
  
  mounted() {
    try {
      if (this.params && this.params.data) {
        let res = jpath.query(this.params.data, this.params.path);
        if (!res) {
          console.error('Path incorrect: ', this.params.path);
          return
        }

        this.rowProperty = (res && Array.isArray(res) && res.length > 0)
          ? res[0]
          : res;
      }
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    hasAccomplished() {
      return this.params.localIndex === 0 
        && this.params.canHaveAccomplished
        && this.rowProperty 
        && this.rowProperty[this.params.localIndex];
    },

    isAccomplished() {
      return this.rowProperty[this.params.localIndex].isAccomplished &&
        this.rowProperty[this.params.localIndex].isAccomplished !== 0;
    },
    
    getSurveyInstance() {
      return this.rowProperty[this.params.localIndex].surveyInstanceId;
    }
  },
  
  computed: {
    /* Well, sorry for the code. Please don't touch it unintentionally */
    trend() {
      if (!this.rowProperty || this.rowProperty.length < 1)
        return null;

      if (this.rowProperty.length - 1 <= this.params.localIndex)
        return null;

      let actualItem = this.rowProperty[this.params.localIndex];
      let actualValue = actualItem?.result !== undefined ? actualItem?.result :
        (  actualItem?.result  
        || actualItem?.value 
        || actualItem?.WaveResult 
        || actualItem?.QuestionResult 
        || actualItem?.Result);
      let act = actualValue;

      let lastItem = this.rowProperty[this.params.localIndex + 1];
      let lastValue = lastItem?.result !== undefined ? lastItem?.result :
        (  lastItem?.result  
        || lastItem?.value 
        || lastItem?.WaveResult 
        || lastItem?.QuestionResult 
        || lastItem?.Result);
      let last = lastValue;

      if (lastItem?.result === '') 
        return null;
  
      if (act === null && last === null) return 0;
      if (act === null && last !== null) return 1;
      if (act !== null && last === null) return -1;
      if (act !== null && last !== null) return act - last;
    }
  }
}
